import React, { PropTypes } from 'react';

const Noscript = ({ value }) => {
  const bild = (typeof value === 'string' && value) || (value && value.marginal);

  console.log("https://quickshot.imgix.net/USAVAL/"+bild+".png");
  const style = require('./Noscript.scss');
  return <noscript><div className={style.wrapper}><img src={"https://quickshot.imgix.net/USAVAL/"+bild+".png"} /><br/><p className={style.p}>Källa: CNN</p></div></noscript>;

};


export default Noscript;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Noscript/Noscript.js
 **/